import { Grid, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";

import FormOne from "./FormOne";
import {
  ButtonFooter,
  ComponentHeader,
  PageHeader,
  Paper,
} from "../../../components";
import FormThree from "./FormThree";
import EditButtons from "../../../components/EditButtons";
import { colors } from "../../css components/Style";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { useState } from "react";

export default function FormDisplay({
  agencyID,
  brandID,
  formikProps,
  editState,
  setEditState,
}) {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <PageHeader
          pageName={"Company Details"}
          pageHeader={
            !formikProps.values.brandID
              ? "Let's add company details"
              : formikProps.values.companyName
          }
          buttons={[
            formikProps.values.is_brand_verified === 1 ||
            formikProps.values.is_agency_verified === 1 ? (
              <CancelButton variant="outlined" onClick={() => navigate(-1)}>
                Back
              </CancelButton>
            ) : (
              <EditButtons editState={editState} setEditState={setEditState} />
            ),
          ]}
        />
      </Grid>

      <Grid size={12}>
        <Paper gridSpacing={4}>
          <Grid size={12}>
            <ComponentHeader
              title={"Company Details"}
              buttons={[
                !formikProps.values.mandatoryDetailsSubmitted &&
                  formikProps.values.agreement && (
                    <Link
                      style={{
                        textDecoration: "none",
                        color: colors.purple,
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      loading={loading}
                      onClick={() => {
                        setLoading(true);
                        window.open(formikProps.values.agreement, "_blank");
                      }}
                      variant="contained"
                    >
                      Download Signed Agreement
                    </Link>
                  ),
              ]}
            />
          </Grid>
          {formikProps.values.is_brand_verified === 1 && (
            <Grid size={12}>
              <Typography variant="h6" color={colors.green}>
                This brand has been verified by admin.
              </Typography>
            </Grid>
          )}

          <FormOne
            agencyID={agencyID}
            brandID={brandID}
            formikProps={formikProps}
            editState={editState}
          />
          <FormThree
            agencyID={agencyID}
            brandID={brandID}
            formikProps={formikProps}
            editState={editState}
          />
        </Paper>

        {editState && (
          <Grid size={12}>
            <ButtonFooter
              disabled={!formikProps.values.verifyNumber}
              editState={editState}
              route={state}
              setEditState={setEditState}
              ID={formikProps.values.ID}
              formikProps={formikProps}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
